// @flow
import type {
  MiddlewareAPI,
  Dispatch,
} from 'redux'

type Action = {
  type: $Subtype<string>,
}

export default function ignoreStore<S, A: Action> (store: MiddlewareAPI<S, A>): (next: Dispatch<A>) => Dispatch<A> {
  return function (next: Dispatch<A>): Dispatch<A> {
    return function (action: A): A {
      if (action.meta && action.meta.ignoreStore) {
        return action
      }

      const state: S = store.getState()
      const result: A = next(action)
      const nextState: S = store.getState()

      if (__DEV__ && state === nextState) {
        const { type } = action
        console.warn(
          `${type} does not mutate state.\n` +
          'If this action does not have any reducers attached to it\n' +
          'and is meant for redux-saga or other middleware you can add\n' +
          'action.meta.ignoreStore = true\n' +
          'to avoid re-rendering of the application and improve performance.'
        )
      }

      return result
    }
  }
}
